import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  const phoneNumber = '2250700592164';
  const whatsappUrl = `https://wa.me/${phoneNumber}`;
  return <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-lg transition-all duration-300 hover:scale-110 group" aria-label="Contact us on WhatsApp" data-id="element-181">
      <MessageCircle className="w-7 h-7" data-id="element-182" />

      {/* Tooltip */}
      <span className="absolute right-full mr-3 px-3 py-2 bg-gray-900 text-white text-sm font-medium rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none" data-id="element-183">
        Chat with us
      </span>
    </a>;
}